<template>
  <q-layout view="hHh Lpr lFf">
    <q-page-container>
      <q-page class="row justify-center items-center bg-grey-2">
        <div class="text-center q-ml-sm q-pa-md">
          <q-img src="/static/frontimgs/emis.jpg" style="width: 785px"></q-img>
        </div>
        <q-card>
          <q-card-section>
            <q-toolbar-title v-if="$q.screen.gt.sm" shrink class="row items-center no-wrap">
              <q-img src="/static/frontimgs/logo.png" style="width: 80px"></q-img>
              <span class="q-ml-sm text-grey-8 text-weight-bold">eMIS服务</span>
            </q-toolbar-title>
            <div>
              欢迎登录！
            </div>
          </q-card-section>
          <q-separator inset></q-separator>
          <span>
            <q-card-section v-if="getValidate.type=='form'">
              <div class="text-negative">{{ getValidate.msg }}</div>
            </q-card-section>
            <q-card-section>
              <q-form class="q-gutter-sm" style="max-width:270px" v-if="!tenant.name">
                <q-input dense filled name="username" v-model="login_data.code" label="租户"
                         :error="getValidate.type=='code'" :error-message="getValidate.msg">
                  <template v-slot:before>
                    <q-icon name="fas fa-building" />
                  </template>
                </q-input>
            </q-form>
              <q-form class="q-gutter-sm" style="max-width:270px" v-else>
                 <q-item>
              <q-item-section>
                  <div class="inline-block">
                      <span @click="tenant={}">
                        <q-btn round color="primary" size="xs" icon="fas fa-angle-double-left">
                          <q-tooltip anchor="top middle" self="bottom middle">返回输入公司代码</q-tooltip>
                        </q-btn>
                      </span>
                      <span class="q-ml-sm text-weight-bold">{{ tenant.name }}({{ tenant.mark }})</span>
                  </div>
              </q-item-section>
            </q-item>
                <q-input dense filled name="username" v-model="login_data.username" label="登录名"
                       :error="getValidate.type=='Username'" :error-message="getValidate.msg">
                  <template v-slot:before>
                    <q-icon name="fas fa-user"></q-icon>
                  </template>
                </q-input>
                <q-input dense filled name="password" v-model="login_data.password" label="密码" type="password"
                       :error="getValidate.type=='Password'" :error-message="getValidate.msg">
                  <template v-slot:before>
                    <q-icon name="fas fa-lock"></q-icon>
                  </template>
                </q-input>
                 <q-input dense filled name="captcha" v-model="login_data.captcha" label="验证码"
                          :error="getValidate.type=='Code'" :error-message="getValidate.msg">
                <template v-slot:before>
                  <q-icon name="fas fa-key" class="q-mr-xs"></q-icon>
                  <q-img :src="captcha_data.base64" class="cursor-pointer" alt="验证码" style="width:78px"
                         @click="get_captcha()">
                    <q-tooltip>点击更换验证码</q-tooltip>
                  </q-img>
                </template>
              </q-input>
            </q-form>
          </q-card-section>
          <q-card-actions class="row justify-center">
            <q-btn color="primary" size="md" v-if="!tenant.name" label="下一步" :loading="isLoginLoading" icon="fas fa-sign-in-alt" @click="next" class="q-mb-md"/>
            <q-btn color="primary" size="md" v-else label="登录系统" :loading="isLoginLoading" icon="fas fa-sign-in-alt" @click="login" class="q-mb-md"/>
          </q-card-actions>
          </span>
        </q-card>
      </q-page>
    </q-page-container>
  </q-layout>
</template>
<script>
import {ref,onMounted} from 'vue'
import {useRouter} from "vue-router";
import {useStore, mapGetters} from 'vuex'
import API from '../apis'
import {useQuasar} from "quasar";
export default {
  name: 'login-view',
  computed: {
    ...mapGetters('page', ['getValidate', 'getResponse']),
    ...mapGetters('user', ['isLogin'])
  },
  watch: {
    getResponse(v1) {
      if (v1) {
        let t = v1.status == 'positive' ? 1 : 3000
        this.$q.notify({
          progress: true,
          timeout: t,
          type: v1.status,
          multiLine: true,
          position: "top-right",
          message: v1.status_code > 400 ? `${v1.title}${v1.status_text}${v1.status_code}，${JSON.stringify(v1.data)}` : `${v1.title}：${v1.status_text}。`
        })
      }
    },
    save(v) {
      if (v) {
        this.$q.notify({
          type: 'warning',
          message: '开启记忆密码会有安全风险，请注意保护您的设备不被盗用。'
        })
      }
    }
  },
  setup() {
    const store = useStore()
    let login_data = ref({})
    let tenant = ref({})
    let isLoginLoading = ref(false);
    const $router = useRouter();
    const $q = useQuasar();
    let save = ref(false)
    if (localStorage.getItem('saveLogin')) {
      save.value = true
      login_data.value = localStorage.getItem('loginFormData') ? JSON.parse(localStorage.getItem('loginFormData')) : {}
    }
    let captcha_data = ref({})

    function get_captcha() {
      API.getCaptcha().then(res => {
        captcha_data.value = res.data.data
      })
    }

    function savedata() {
      let save_data = {username: login_data.value.username, password: login_data.value.password}
      if (save.value) {
        localStorage.setItem('saveLogin', 1)
        localStorage.setItem('loginFormData', JSON.stringify(save_data))
      } else {
        localStorage.removeItem('saveLogin')
        localStorage.removeItem('loginFormData')
      }
    }
   function next(){
      if (!login_data.value.code){
        store.dispatch('page/error',{data:"请填写公司代码。",type:'code'}, {root: true})
        return
      }
     store.dispatch('user/step_login', login_data.value.code).then(res=>{
       tenant.value = res.data
      })
    }

    function login() {
      if (!login_data.value.username) {
        store.dispatch('page/error', {data: "请填写登录名", type: 'username'});
        return
      }
      if (!login_data.value.password) {
        store.dispatch('page/error', {data: "请填写登录密码", type: 'password'});
        return
      }
      let gotoHome =(isOk)=>{
        isLoginLoading.value = false;
        if(isOk){
          $router.push({name: 'sso',query:{isLoginSuccess:true}});
        }
      }
      let loginError =()=>{
        $q.notify({
          progress: true,
          timeout: 5000,
          type:'negative',
          multiLine: true,
          position: "top-right",
          message: '登录失败，请联系工作人员！',
          caption: '',
        });
      }
      isLoginLoading.value = true;
      store.commit('user/logout');//点击登录时 先清空登录状态信息
      let params = {
        mark:tenant.value.mark,
        username:login_data.value.username,
        password:login_data.value.password,
        cid:captcha_data.value.cid,
        code:login_data.value.captcha,
        // isLock:true
      }
      store.dispatch('user/login', {
        params:params,
        gotoHome,
        loginError,
        tenant:tenant.value
      }).catch(()=>{
        get_captcha()
      })
    }

    // 获取图片
    get_captcha()
    store.commit('user/logout');//点击登录时 先清空登录状态信息
    return {
      save, login_data, captcha_data, get_captcha, next,login,tenant,isLoginLoading
    }
  }
}
</script>
